(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/widgets-campaign/views/index.js') >= 0) return;  svs.modules.push('/modules/widgets-campaign/views/index.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.widgets_campaign=_svs.widgets_campaign||{};
_svs.widgets_campaign.templates=_svs.widgets_campaign.templates||{};
svs.widgets_campaign.templates.index = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n<div class=\"js-react-container react-container relative\" id=\"reactContainer\">\n</div>\n";
},"useData":true});
Handlebars.partials['svs-widgets_campaign-index'] = svs.widgets_campaign.templates.index;
})(svs, Handlebars);


 })(window);